import { render, staticRenderFns } from "./header-text.vue?vue&type=template&id=715ab04b&"
import script from "./header-text.vue?vue&type=script&lang=ts&"
export * from "./header-text.vue?vue&type=script&lang=ts&"
import style0 from "./header-text.vue?vue&type=style&index=0&id=715ab04b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports